export default "__VITE_ASSET__DwmeeQjW__"